module.exports = __webpack_public_path__ + "img/avatar-default.9a75f1b5.png";